import { z } from "zod/v4"

export const AssetBundleFile = z.object({
  android: z.url(),
  ios: z.url(),
  linux: z.url(),
  windows: z.url().optional(),
  mac: z.url().optional(),
}).describe("OSごとのAssetBundle URL。")

export const UploadAssetBundleRequest = z.object({
  assetBundleName: z.string().optional(),
  windowsAssetBundleName: z.string().optional(),
  macAssetBundleName: z.string().optional(),
})
export type UploadAssetBundleRequest = z.infer<typeof UploadAssetBundleRequest>
